import TiptapTextAlign from "@tiptap/extension-text-align";

import TextAlignMenuButton from "../../extensions/TextAlign/components/TextAlignMenuButton";

export const TextAlign = TiptapTextAlign.extend({
	addOptions() {
		return {
			...this.parent?.(),
			types: ["heading", "paragraph", "list_item", "title"],
			button({ editor, extension, t }) {
				const alignments = extension.options?.alignments || [];
				const shortcutKeysMap = {
					left: ["mod", "Shift", "L"],
					center: ["mod", "Shift", "E"],
					right: ["mod", "Shift", "R"],
					justify: ["mod", "Shift", "J"]
				};
				const iconMap = {
					left: "AlignLeft",
					center: "AlignCenter",
					right: "AlignRight",
					justify: "AlignJustify"
				};
				const items = alignments.map(k => ({
					title: t(`editor.textalign.${k}.tooltip`),
					icon: iconMap[k],
					shortcutKeys: shortcutKeysMap[k],
					isActive: () => editor.isActive({ textAlign: k }) || false,
					action: () => editor.commands?.setTextAlign?.(k)
				}));
				const disabled = items.filter(k => k.disabled).length === items.length;
				return {
					component: TextAlignMenuButton,
					componentProps: {
						icon: "AlignJustify",
						tooltip: t("editor.textalign.tooltip"),
						disabled,
						items
					}
				};
			}
		};
	}
});
